import React, { useRef, useState, useEffect } from "react";
import {useLocation} from "react-router-dom";

/**
 * 공통 사용 푸터
 */

const Footer = () => {
    const location = useLocation();
    const [lastScrollY, setLastScrollY] = useState(0);
    const topContainer = useRef(null);
    const scrollTop = useRef(null);

    const scrollToTop  = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }
    // 메인 페이지인지
    const isMain = () => {
        return location.pathname === '/'
    }

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (scrollTop.current) {
                clearTimeout(scrollTop.current);
            }
    
            // 맨 위에 있을 때는 버튼 숨기기
            if (currentScrollY === 0) {
                // 스크롤이 맨 위에 있을 때
                topContainer.current?.classList.remove("show", "show2");
                scrollTop.current = setTimeout(() => {
                    topContainer.current?.classList.add("show2");
                }, 300);
            } else if (lastScrollY < currentScrollY) {
                // 스크롤 DOWN (내릴 때)
                requestAnimationFrame(() => {
                    topContainer.current?.classList.add("show");
                    scrollTop.current = setTimeout(() => {
                        topContainer.current?.classList.add("show2");
                    }, 10);
                });
            } else {
                // 스크롤 UP (올릴 때)
                requestAnimationFrame(() => {
                    topContainer.current?.classList.remove("show2");
                    scrollTop.current = setTimeout(() => {
                        topContainer.current?.classList.add("show");
                    }, 300);
                });
            }
            setLastScrollY(currentScrollY);
        }; 

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollY]);

    return (
        <footer id="footer">
            <p className="copyright">Copyright © 한국근대교육사연구센터</p>
            {!isMain() && (
                <div className="top" ref={topContainer}>
                    <button className="go-top" onClick={scrollToTop}>상단으로 가기</button>
                </div>
            )}
        </footer>
    );
}

export default Footer;